import React from 'react';
import { Table, Skeleton } from 'antd';

import { KpiReport } from '../styles';
import { TABLE_SCROLL_SETTINGS } from './constants';

const ReportTable = ({
  loading, data, title, getColumns, width,
}) => (
  <KpiReport style={{ width }}>
    <h2>{title}</h2>
    { loading ? (
      <Skeleton
        active
      />
    ) : (
      <Table
        scroll={TABLE_SCROLL_SETTINGS}
        size="small"
        pagination={false}
        rowKey="label"
        dataSource={data}
        columns={getColumns(data)}
        bordered
      />
    )}
  </KpiReport>
);

export default ReportTable;
